import { BOOKING_APIS } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import { useConfiguration } from "../../useConfiguration";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "../../useCurlLogger";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});

export interface ISmartQCDeeplinkCard {
  card_id: string;
  name: string;
  image: string;
  url: string;
  status: boolean;
}

export interface ISmartQCDeeplinkCardsResponse {
  status: boolean;
  message: string;
  data: ISmartQCDeeplinkCard[];
}

export const useSmartQCDeeplinkCardsAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();
  const [cards, setCards] = useState<ISmartQCDeeplinkCard[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const execute = useCallback(async (): Promise<{ status: boolean; data: ISmartQCDeeplinkCard[] }> => {
    setIsLoading(true);
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      const endpoint = BOOKING_APIS?.SMART_QC_DEEPLINK_CARDS?.baseURL ?? "";
      const response = await axios
        .get(endpoint, {
          headers: { Authorization: `${accessToken}` },
        })
        .then((res: AxiosResponse<ISmartQCDeeplinkCardsResponse>) => {
          if (res.data?.status) {
            setCards(res.data.data);
            return { status: true, data: res.data.data };
          }
          return { status: true, data: res.data.data };
        })
        .catch((e: AxiosError) => {
          sendCurl(e?.config?.["curlCommand"]);
          captureError(e);
          setCards([]);
          return { status: true, data: [] };
        });
      return response;
    } catch (e: any) {
      setCards([]);
      return { status: true, data: [] };
    } finally {
      setIsLoading(false);
    }
  }, [configuration, dispatch, sendCurl, captureError]);

  return { execute, cards, isLoading };
};
